'use client';
import type React from 'react';

import { useAtomValue } from 'jotai';

import { Loading } from '@core/Components/Loading/Loading';
import type { Tenant } from '@core/Entities/App/Tenants.entity';
import type { Locale } from '@core/Entities/Locale/Locale.entity';
import type { DealershipsDealer } from '@core/Entities/Vehicle/Dealer.entity';
import type { RegionAreaAtom, RegionAtom } from '@search/Atoms/RegionAtom.entity';
import { shouldShowRegionLoaderAtom } from '@search/Atoms/RegionLoadingStateAtom';

import { DealerLocationHeader } from './DealerLocationHeader';
import { DealersCard } from './DealersCard';

import styles from './DealersSectionWrapper.module.css';

interface DealersSectionWrapperProps {
  dealers: DealershipsDealer[];
  strs: Record<string, string>;
  locale: Locale;
  tenant?: Tenant;
  region: RegionAtom;
  area: RegionAreaAtom;
}

export const DealersSectionWrapper: React.FC<DealersSectionWrapperProps> = ({
  dealers,
  strs,
  locale,
  tenant,
  region,
  area,
}) => {
  const shouldShowLoader = useAtomValue(shouldShowRegionLoaderAtom);

  if (shouldShowLoader) {
    return <Loading />;
  }

  return (
    <section className={styles.wrapper}>
      <DealerLocationHeader strs={strs} region={region} area={area} />
      <ul className={styles.dealersSection}>
        {dealers.map(dealer => (
          <li key={dealer.dealerId} className={styles.dealersCard}>
            <DealersCard
              tenant={tenant}
              dealer={dealer}
              locale={locale}
              carsLabel={strs.carsLabel}
            />
          </li>
        ))}
      </ul>
    </section>
  );
};
